/* BESOCKS · ficha de producto: carrusel en movimiento continuo (ordenador) y cantidad junto a la talla */
(function () {
  var main = document.querySelector('main[data-template^="product"]');
  if (!main) return;
  var desktop = window.matchMedia('(min-width: 990px)');

  /* ---------- 1. Carrusel en movimiento continuo (solo plantilla principal, solo ordenador) ---------- */
  function buildMarquee() {
    if (!/^product(\.pdp-b)?$/.test(main.getAttribute('data-template'))) return;
    var media = document.querySelector('.product-information__media');
    if (!media || media.querySelector('.bs-marquee')) return;
    var imgs = Array.prototype.slice.call(media.querySelectorAll('slideshow-slide img'));
    if (imgs.length < 2) return; /* con una sola foto, se deja la foto fija */
    /* Espera a que la galeria haya elegido y cargado cada foto; asi el carrusel usa esas mismas */
    var pending = imgs.filter(function (img) { return !img.currentSrc; });
    if (pending.length) {
      if (!buildMarquee.waiting) {
        buildMarquee.waiting = true;
        pending.forEach(function (img) {
          img.loading = 'eager';
          img.addEventListener('load', function () { buildMarquee.waiting = false; if (desktop.matches) buildMarquee(); }, { once: true });
        });
      }
      return;
    }

    var h = window.innerHeight;
    var setWidth = 0;
    var set = imgs.map(function (img) {
      var w = +img.getAttribute('width') || 3, hh = +img.getAttribute('height') || 4;
      setWidth += h * (w / hh);
      var c = document.createElement('img');
      /* Reutiliza exactamente la foto que ya ha descargado la galeria (sin segundas descargas) */
      c.src = img.currentSrc;
      c.alt = img.alt || '';
      c.width = w; c.height = hh;
      c.decoding = 'async';
      return c;
    });

    /* repetimos la serie hasta cubrir la pantalla, y luego la duplicamos para el bucle */
    var reps = Math.max(1, Math.ceil(window.innerWidth / setWidth));
    var track = document.createElement('div');
    track.className = 'bs-marquee__track';
    for (var r = 0; r < reps * 2; r++) {
      set.forEach(function (img, i) {
        var n = img.cloneNode(true);
        if (r > 0 || i > 0) n.setAttribute('aria-hidden', 'true');
        track.appendChild(n);
      });
    }
    var wrap = document.createElement('div');
    wrap.className = 'bs-marquee';
    var speed = 45; /* px por segundo */
    wrap.style.setProperty('--bs-marquee-duration', Math.round((setWidth * reps) / speed) + 's');
    wrap.appendChild(track);
    media.appendChild(wrap);
    media.classList.add('bs-has-marquee');
  }

  function removeMarquee() {
    var media = document.querySelector('.product-information__media');
    if (!media) return;
    var m = media.querySelector('.bs-marquee');
    if (m) m.remove();
    media.classList.remove('bs-has-marquee');
  }

  function syncMarquee() {
    if (desktop.matches) buildMarquee(); else removeMarquee();
  }

  /* ---------- 2. Cantidad en la misma fila que la talla ---------- */
  function placeQty() {
    var details = document.querySelector('.product-details');
    if (!details) return;
    var row = details.querySelector('variant-picker fieldset .variant-option__button-label');
    var buttons = details.querySelector('.product-form-buttons');
    var qty = details.querySelector('.quantity-selector-wrapper');
    if (!row || !buttons || !qty) { details.classList.remove('bs-qty-inline'); return; }
    details.classList.add('bs-qty-inline');
    var offset = buttons.getBoundingClientRect().top - row.getBoundingClientRect().top;
    buttons.style.setProperty('--bs-qty-top', (-offset) + 'px');
  }

  function init() {
    syncMarquee();
    placeQty();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', placeQty);
  var t;
  window.addEventListener('resize', function () {
    clearTimeout(t);
    t = setTimeout(function () { removeMarquee(); syncMarquee(); placeQty(); }, 200);
  });
  /* Horizon vuelve a pintar la ficha al cambiar de talla */
  document.addEventListener('variant:update', function () { setTimeout(placeQty, 60); });
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('variant-picker')) setTimeout(placeQty, 300);
  });
})();